export class Country {
    constructor(
        public id = 0,
        public name = '',
        public iso = '',
        public nicename = '',
        public iso3 = '',
        public numcode = 0,
        public phonecode = 0
    ) {
    }
}